import { CallMessageModel } from "./CallMessageModel";
import { CallRoomModel } from "./CallRoomModel";
import { CallSessionModel } from "./CallSessionModel";

export class WebsocketEventModel {
  readonly event: WebsocketEventTypes;
  readonly room: CallRoomModel;
  readonly session: CallSessionModel;
  readonly clientId: string;
  readonly callMessage?: CallMessageModel | CallMessageModel[];
  constructor(_model: WebsocketEventModel) {
    if (!Object.values(WebsocketEventTypes).includes(_model.event)) {
      throw new Error("Invalid event type");
    }

    this.event = _model.event;
    this.room = _model.room;
    this.session = _model.session;
    this.clientId = _model.clientId;
    this.callMessage = _model.callMessage;
  }
}

export enum WebsocketEventTypes {
  CONNECT = "connect",
  ANSWER = "answer",
  REJECT = "reject",
  TERMINATE = "terminate",
  TRANSFER = "transfer",
  NEW_MESSAGE = "new-call-room-message",
  NEW_CALL = "new-call",
}
